import { Direccion, DireccionDTO } from "./direccion";
import { Paquete, Sobre, PaqueteDTO, SobreDTO } from "./servicio";
import { PagoGuiasGuia } from "./pago";
import { ContactoCliente } from "./cliente";
import { MatrizTarifaGlobales } from "./matriztarifa";
import { StatusGuiaViewDTO, StatusGuia } from "./status";

export enum TipoSeguroGuia {
    Interno = 0,
    Externo = 1
}

export enum TipoAcuse {
    Interno = 0,
    Externo = 1,
}

/**Una guia contiene varios paquetes y sobres los cuales fueron enviados por un cliente */
export interface Guia {
    /**Llave primaria */
    IdRegistro: number;

    /**Id de la documentación de la cual partió esta guia */
    IdDocumentacion: number;


    /**Id de cliente destino */
    IdClienteDestino: number;

    /**Id de cliente destino */
    IdClienteOrigen: number;

    /**Id de la colonia de destino */
    IdColoniaDestino: number;

    /**La dirección de destino */
    DireccionDestino: Direccion;

    /**
     * Listado de @see Paquete  relacionado con esta entidad
     */
    Paquetes: Paquete[];

    /**
     * Listado de @see Sobre  relacionado con esta entidad
     */
    Sobres: Sobre[];

    /**El pago de la guia. Es null si la guia NO se ha pagado */
    PagoGuiasGuia: PagoGuiasGuia;

    /**Servicios que se van a incluir con esta guia */
    ServiciosAdicionales: ServiciosAdicionalesGuia;

    /**Indica si esta guia la va a pagar el destinatario */
    FletePorCobrar: boolean;

    /**Importes de la guía */
    Tasas: TasasGuia;

    /**Importe total de la guia calculado en memoria en el momento de su documentación. Este valor se utiliza para obtener el facto de descueto real de la guia */
    ImporteTotalSinDescuento: number;

    /**Distancia calculada del flete la cual se utilizó para calcular el importe del flete */
    DistanciaFlete: number;

    NombreTarifa: string;
    RfcClientePaga: string;

    /**Status de la guia */
    Status: StatusGuia;

    /**
       * Id de la dirección del cliente que se seleccionó para el envio. NOTA: No utilize esta relacion para obtener la direccion de destino, ya que esta puede cambiar. Utilize directamente @see Guia.DireccionDestino 
       * Esta relación se utiliza para obtener los contactos del cliente que puedenr recibir la guia
       */
    IdDireccionClienteDestino: number;

    /**Contacto del cliente que recibió la guia */
    IdContactoClienteRecibio: number | null;

    /**Documento requerido en el acuse externo. Solo es valido si TipoAcuse == Externo, esto esta comprobado con un CHECK */
    IdRequerimientoAcuse: number | null;

    /**Sucursal de destino. Este valor parte de la asignación entre los municipios y las sucursales, pero se almacena aqui en caso de que la asignación cambie */
    IdSucursalDestino: number;

    /**Es la clave que utilizará en cliente en conjunto con el folio para realizar la facturación online */
    ClaveGuiaCliente: number;

    /**
     * En caso de que esta guía sea de entrega en zona extendida, este es el ingreso pagado al que la entregó
     * Este ingreso es calculado según la tarifa del pago al chofer, 
     */
    IngresoZonaExt: number | null;

    /**Indica que por alguna razón está guía no es facturable o no se debe de facturar */
    NoFacturable: boolean;

}

export interface ServiciosAdicionalesGuia {
    /**Si incluye entrega a domicilio */
    EntregaDomicilio: boolean;
    /**Si incluye recolección a domicilio */
    RecoleccionDomicilio: boolean;

    /**Tipo de acuse o null si no lleva acuse */
    TipoAcuse: TipoAcuse | null;

    //importeGastoAdministrativo: number;
}

export interface ServiciosAdicionalesGuiaDTO extends ServiciosAdicionalesGuia {
    NombreRequerimientoAcuse: string;
}

export interface TasasGuia {
    TasaIva: number;
    TasaDescuentoFlete: number;
    /**Tasa de retencion para las personas fisicas */
    RetencionIvaPersonaFisica: number;
    /**Tasa de retención para las personas morales */
    RetencionIvaPersonaMoral: number;

    /**
     * Valores globales de la tarifa al momento de la guia
     * </summary
     */
    TarifaGlobales: MatrizTarifaGlobales;

    /**
     * Si el importe asegurado de una guia es mayor a este valor, la guia se considera que tiene un seguro externo, en otro caso, se considera que tiene un seguro interno. Este tipo de seguro
     * afecta a la contabilización de la guia
     */
    LimiteSeguroInterno: number;

    /**Nombre de la tarifa */
    NombreTarifa: string;
}

export interface ImportesGuiaDTO {
    Flete: number;
    Seguro: number;
    EntregaDomicilio: number;
    /**Importe debido a las entregas de zona extendida */
    ZonaExtendida: number;

    RecoleccionDomicilio: number;
    Acuse: number;
    ImporteDescuentoFlete: number;
    FleteSinDescuento: number;
    Subtotal: number;
    Iva: number;
    Total: number;
    /**Subtotal * RetencionIva */
    RetencionIva: number;
    /**Tasa de IVA que aplico para esta guia */
    TasaIva: number;
    /**Tasa de retención de IVA que aplicó para la guia */
    TasaRetencionIva: number;
    /**Tasa de descuento del flete */
    TasaDescuentoFlete: number;

    /**Valor declarado de la guía */
    ValorFactura: number;

    /**Valor factura de la guia */
    ServicioEspecial: number;

    ImporteGastoAdministrativo: number;
}



/**VIEW de los folios de las guias */
export interface GuiaFolio {
    /**Id de la guia */
    IdGuia: number;
    Guia: Guia;

    /**Folio de la guia */
    Folio: string;
}

/**DTO de las guias */
export interface GuiaDTO extends Guia {
    Folio: string;

    /**Es true si la guía está facturada y la factura no está cancelada */
    EsFacturada: boolean;

    /**Enum que indica si la guía está facturada o no */
    GuiaFacturada: StatusGuiaFacturacion;

    /**si la guía está facturada este campo contendrá el folio de la factura que incluye a esta guía */
    FolioFactura: string;

    NombreClienteOrigen: string;
    DireccionOrigenDTO: DireccionDTO;

    NombreClienteDestino: string;
    DireccionDestinoDTO: DireccionDTO;
    Pagada: boolean;
    Documentacion: DocumentacionDTO;
    FechaCreacion: Date;

    Paquetes: PaqueteDTO[];
    Sobres: SobreDTO[];
    /**Contiene la concatenación de las observaciones de sobre sy paquetes */
    Observaciones: string[];

    /**Suma de los pesos de los paquetes */
    Peso: number;
    /**Suma de los volumenes de los paquetes */
    Volumen: number;
    /**Suma de los pesos volumetricos de los paquetes */
    PesoVolumetrico: number;

    /**Descripciones de los volumenes de los paquetes */
    DescripcionPaquetesVolumen: string | null;

    /**Descripciones de los contenidos y descripciones de los paquetes */
    DescripcionPaquetesTexto: string | null;

    /**Cantidad total de paquetes */
    CantidadPaquetes: number;

    /**Cantidad total de sobres */
    CantidadSobres: number;
    ImporteTotal: number;

    /**True si el cliente destino de esta guia tiene como requerimiento que los paquetes sean entregados a un contacto autorizado */
    RequiereContactoAutorizado: boolean;
    ContactoClienteRecibio: ContactoCliente;
    /**True si la guia ya fue entregada, este valor esta en función del status */
    Entregada: boolean;


    NombreSucursalOrigen: string;
    NombreSucursalDestino: string;

    /**Id de la sucursal del status de la guia */
    IdSucursalStatus: number | null;
    /**Nombre de la sucursal del status de la guia */
    NombreSucursalStatus: string;

    Importes: ImportesGuiaDTO;

    ServiciosAdicionales: ServiciosAdicionalesGuiaDTO;
    NombreContactoRecibio: string;

    /**Indica si esta guia es una guia de acuse de otra guia */
    EsDeAcuse: boolean;

    /**Folio de la guia que genero este acuse, en caso de que la guia sea de acuse */
    FolioGuiaAcuse: string;

    /**Nombre del requerimiento del acuse de la guia original de este acuse. Solo es valido si esta guia es un acuse externo */
    NombreRequerimientoAcuseGuiaAcuse: string;

    /**True si se puede imprimir un acuse de recibo interno de esta guia */
    PuedeImprimirAcuseInterno: boolean;

    /**Status historicos de la guia */
    StatusHistoricos: StatusGuiaViewDTO[];

    /**True si la guia se encuentra en la sucursal de origen */
    EnSucursalOrigen: boolean;
    /**True si la guia se encuentra en la sucursal destino */
    EnSucursalDestino: boolean;

    /**Nombre de la sucursal u origen y destino del viaje actual */
    Posicion: string;

    /**Fecha de entrega de la guia */
    FechaEntrega: Date | string | null;

    /**Fecha en la que se pagó la guía */
    FechaDePago: Date | string | null;

    /**Fecha en la que se facturó la guía */
    FechaDeFacturacion: Date | string | null;

    /**Fecha en que se registro una poliza a partir de la guía */
    FechaDePoliza: Date | string | null;

    /**Es null si aun no ha sido pagada la guia, si ya fue pagada, es true si fue pagada con credito */
    EsDeCredito: boolean | null;

    /**Id del cliente que paga la guia */
    IdClientePaga: number;

    /**Nombre del cliente que paga la guia */
    NombreClientePaga: string;

    /**Id de la sucursal de cobranza del cliente que paga */
    IdSucursalCobranza: number | null;

    /**Nombre de la sucursal de cobranza */
    NombreSucursalCobranza: string;

    /**Folio de la recolección a domicilio */
    FolioRecoleccionDomicilio: string;

    /**True si esta guia se puede recolectar */
    PuedeRecolectar: boolean;

    /**
 * True si la guia fue documentada por un usuario con el permiso @see PermisosDocumentacion.DocumentacionEnSucursal 
 */
    DocumentadoEnSucursal: boolean;

    /**nombre de la persona que hizo la documentación de la guía */
    NombrePersonaDocumento: string;

    /**Nombre de la persona que entregó la guía */
    NombrePersonaEntrego: string;

    /**Valor declarado para el seguro de la guia */
    ValorDeclarado: number;

    /**Tipo del seguro de la guia */
    TipoSeguro: TipoSeguroGuia | null;

    /**Indica que la guía fue rechazada por el cliente al momento de entregarsela */
    Rechazado: boolean;

    /**Motivo del rechazo a domicilio, motivos de los rechazos de la guía */
    MotivoRechazo: string;

    /**Motivo por el cual se canceló está guía en la facturación */
    MotivoCancelacion?: string | null;

    /**Nombre de la ruta de entrega a domicilio */
    NombreRutaEntregaDomicilio: string;

    /**Obtiene la fecha limite de facturación antes de que entre a público general, esto sólo aplica para las guías de contado */
    FechaLimiteFacturacion: Date | string | null;

    /**son las observaciones que se registraron en la guia */
    ObservacionesGuia: string;

    /**es true si la guía está cancelada */
    EsCancelada: boolean;

    /**Es true si la guía pertenece a una zon extendida */
    EsZonaExtendida: boolean;

    /**Nombre de la zona extendida */
    NombreZonaExtendida: string;

    /**Motivo por el que la guía no aplica para publicó general */
    MotivoRechazoPublicoGeneral: string;

    EsGuiaPP:boolean;

    ImporteGuiaPP: number;

    ImporteTotalConGuiaPP:number;
}

export interface GuiaConsulta {
    Folio: string;
    FolioFactura: string;
    Status: StatusGuia;
    NombreSucursalStatus: string;
    FechaCreacion: Date | string;
    IdClienteDestino: number;
    IdClienteOrigen: number;
    IdSucursalDestino: number;
    IdSucursalOrigen: number;
    IdSucursalStatus: number | null;
    Entregada: boolean;
    EsFacturada: boolean;
    EnSucursalOrigen: boolean;
    EnSucursalDestino: boolean;
    FletePorCobrar: boolean;
    EsDeCredito: boolean | null;
    EsDeAcuse: boolean;
    PuedeImprimirAcuseInterno: boolean;
    NombreSucursalOrigen: string;
    NombreSucursalDestino: string;
    NombreClienteOrigen: string;
    NombreClienteDestino: string;
    CantidadPaquetes: number;
    Peso: number;
    PesoVolumetrico: number;
    Volumen: number;
    DescripcionPaquetesTexto: string;
    CantidadSobres: number;
    ServiciosAdicionales: ServiciosAdicionalesGuiaDTO;
    ImporteTotal: number;
    FolioGuiaAcuse: string;
    FechaEntrega: Date | string | null;
    ValorDeclarado: number;
    MotivoRechazo: string;
    DireccionOrigen: string;
    DireccionDestino: string;
    EsCancelada: boolean;
    NombreContactoRecibio: string;
    ObservacionesGuia: string;
    NombrePersonaDocumento: string;
    MotivoRechazoPublicoGeneral: string;
    NoFacturable: boolean;
    EsGuiaPP: boolean;
    ManifiestoRAD: number | null;

    IdRegistro: number;
    EsGuiaZonaExtendida: boolean;
    ImporteGuiaPP:number;
    ImporteTotalConGuiaPP:number;

    ImportesValores: ImportesGuiaDTO;

    IdPaquetePP: number | null;

}


/**Agrupa un conjunto de guias creado gracias a una documentacion, Este representa una entidad de la base de daatos */
export interface Documentacion {
    IdRegistro: number;

    /**Id de cliente origen */
    IdClienteOrigen: number;

    /**Id de la colonia de origen */
    IdColoniaOrigen: number;

    /**Nombre del contacto de origen, no se almacena el IdContactoOrigen para que permanezcan los valores originales de nombre y dirección en caso de que cambien */
    NombreContactoOrigen: string;

    /**La dirección de origen */
    DireccionOrigen: Direccion;

    /**Fecha real de creación de la documentación */
    FechaCreacion: Date;

    /**Listado de las guias creadas con esta documentación */
    Guias: Guia[];

    /**Divisor del peso volumetrico al momento de esta documentación, este valor va a determinar los pesos volumetricos de todos los paquetes de todas las guias de esta documentación */
    DivisorPesoVolumetrico: number;

    /**Id de vendedor del cliente de origen que se tenía al crear está documentación */
    IdVendedorCliente: number | null;


    /**
     * True si la guia fue documentada por un usuario con el permiso @see PermisosDocumentacion.DocumentacionEnSucursal 
     */
    DocumentadoEnSucursal: boolean;

    /**Nombre del usuario que documentó  */
    NombreUsuarioDocumento: string;

    /**Nombre del vendedor de la documentación */
    NombreVendedorCliente: string;
}
/**Importes de la guía calculados en su documentación */
export interface ImportesGuia {
    /**Importe debido al flete antes de aplicar el descuento */
    FleteSinDescuento: number;

    /**
     * Flete con el descuento ya aplicado. Es @see Flete  - @see ImporteDescuentoFlete 
     */
    Flete: number;

    /**Importe debido a los paquetes asegurados */
    Seguro: number;

    /**Importe debido a las entregas a domicilio */
    EntregaDomicilio: number;

    /**Importe debido a las entregas de zona extendida */
    ZonaExtendida: number;

    /**Importe debido a la recolección a domicilio */
    RecoleccionDomicilio: number;

    /**Importes del acuse */
    Acuse: number;

    /**Importe del descuento del flete. Es Flete * TasaDescuentoFlete */
    ImporteDescuentoFlete: number;

    /**Tasa de IVA que aplico para esta guia */
    TasaIva: number;

    /**Tasa de retención de IVA que aplicó para la guia */
    TasaRetencionIva: number;

    /**Tasa de descuento del flete */
    TasaDescuentoFlete: number;

    /**Tipo de seguro de la guia */
    TipoSeguro: TipoSeguroGuia | null;

    /**Valor declarado de la guia */
    ValorDeclarado: number;

    /**Valor factura de la guia */
    ValorFactura: number;

    /**Valor del servicio adicional para la guía */
    ServicioEspecial: number;

}
/**DTO de la documentación */
export interface DocumentacionDTO extends Documentacion {
    CantGuias: number;
    ImporteOrigen: number;
    ImporteDestino: number;

    NombreClienteOrigen: string;
    DireccionOrigenDTO: DireccionDTO;
    NombreSucursalOrigen: string;
    /**Listado de las guias creadas con esta documentación */
    Guias: GuiaDTO[];
}

export enum StatusGuiaFacturacion {
    Facturada,
    NoFacturada
}


// WEBPACK FOOTER //
// ./app/models/guia.ts